<div class="pin-boxes">
  <hub-pin-box *ngFor="let p of pinBoxesElementDummy" (click)="focusInput()"></hub-pin-box>
</div>
<input class="pin-input" type="tel" (keydown)="blockKeys($event)" #pinFormInput />
